export class Country {
  countryName: string;
  status: boolean;
  id: number;
}
